export enum TextAusrichtung {
  TEXTAUSRICHTUNG_LINKSBUENDIG = 'TextLinksbuendig',
  TEXTAUSRICHTUNG_RECHTSBUENDIG = 'TextRechtsbuendig',
  TEXTAUSRICHTUNG_ZENTRIERT = 'TextZentriert',
}
